import { Typography } from "components/Typography";

function ContactUsList() {
  return (
    <div>
      <Typography variant="footerHeading">Quicklinks</Typography>
      <Typography variant="footerSmall">(+234)-254-254-254</Typography>
      <Typography variant="footerSmall">Info@Isemajafrica.com</Typography>
      <Typography variant="footerSmall">
        Helios Tower 75 Tam Trinh Hoang
      </Typography>
      <Typography variant="footerSmall">Mai-Ha Noi-viet Nam</Typography>
    </div>
  );
}

export default ContactUsList;
